import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Archive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M8.95 14.549c0-.617.5-1.118 1.118-1.118h23.864a1.118 1.118 0 1 1 0 2.236H10.068c-.618 0-1.119-.5-1.119-1.118ZM13.05 8.96a1.118 1.118 0 1 0 0 2.236h17.9a1.118 1.118 0 1 0 0-2.235h-17.9Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.424 27.96c0-.617.5-1.117 1.118-1.117h14.916c.617 0 1.118.5 1.118 1.118v4.47c0 .618-.5 1.118-1.118 1.118H14.542c-.617 0-1.118-.5-1.118-1.118v-4.47Zm2.237 1.118v2.236h12.678v-2.236H15.661Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.815 4.984A4.102 4.102 0 0 1 12.33 3h20.005c1.49 0 2.862.807 3.585 2.107l7.565 13.6c.338.608.516 1.294.516 1.99v16.205A4.1 4.1 0 0 1 39.898 41H4.102A4.1 4.1 0 0 1 0 36.902v-16.15c0-.744.203-1.475.588-2.113L8.815 4.984Zm3.514.251c-.653 0-1.26.343-1.597.902L2.745 19.392h38.56L33.964 6.193a1.865 1.865 0 0 0-1.63-.958H12.33Zm29.434 16.392H2.237v15.275c0 1.029.835 1.863 1.865 1.863h35.796c1.03 0 1.865-.834 1.865-1.863V21.627Z"
  }));
});
Archive.displayName = 'Archive';
Archive.defaultProps = {
  'aria-label': 'Archive'
};
export default Archive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Archive.js
// module id = 3720
// module chunks = 11